<template>
  <div class="page-results">
    <span
      v-if="getTotalResults > 0"
      class="page-results__indicator"
    >
      {{ getLowerPageResultRange }}-{{ getUpperPageResultRange }} out of {{ getTotalResults }} results
    </span>
    <span
      v-else
      class="page-results__indicator"
    >
      0 results
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PageResultsIndicator',
  computed: {
    ...mapGetters({
      currentPageNumber: 'pageNumber/getCurrent',
      getTotalResults: 'results/getNumOfResults'
    }),
    getLowerPageResultRange () {
      return ((this.currentPageNumber - 1) * 10) + 1
    },
    getUpperPageResultRange () {
      const pageLimit = 10
      return this.getTotalResults < (pageLimit * this.currentPageNumber) ? this.getTotalResults : pageLimit * this.currentPageNumber
    }
  }
}
</script>

<style scoped lang="scss">
@use 'mixins' as *;

.page-results__indicator {
  font-size: 1em;
  display: block;
  padding: 0.5rem 0;
  text-align: center;

  @include breakpoint-md {
    text-align: right;
  }
}

.careers--component .page-results {
  display: none;
}
</style>
